import { formatDate } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GetAccount } from '@app/finxone-web-frontend/app/lib/actions/account.action';
import {
  GetCardTransactionDetailById,
  GetCardTransactions,
} from '@app/finxone-web-frontend/app/lib/actions/card-management.action';
import { GetCards } from '@app/finxone-web-frontend/app/lib/actions/card.actions';
import { GetSavingAccount } from '@app/finxone-web-frontend/app/lib/actions/savings-account.action';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { ApiActions, ApiLoadingState } from '@app/finxone-web-frontend/app/lib/state/api-loading.state';
import { CardManagementState } from '@app/finxone-web-frontend/app/lib/state/card-management.state';
import { CardState } from '@app/finxone-web-frontend/app/lib/state/card.state';
import { ProjectSettingsState } from '@app/finxone-web-frontend/app/lib/state/project-settings.state';
import {
  SavingsAccountState,
  SavingsAccountStateModel,
} from '@app/finxone-web-frontend/app/lib/state/savings-account.state';
import { validateDateRange } from '@app/finxone-web-frontend/app/lib/utils/date-handling.utils';
import { WidgetGridConfig } from '@app/finxone-web-frontend/app/lib/utils/grid.types';
import { filterIfHandlebarNotRendered } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import {
  createRedirectionUrlFromNavigationOptions,
  ifMultiCurrencyAccountSetCurrencyConfig,
} from '@app/finxone-web-frontend/app/lib/utils/utils';
import { TransactionHistoryTopRightOption } from '@app/finxone-web-frontend/app/lib/utils/widget.utils';
import { formatNameAsUrl } from '@app/finxone-web-frontend/app/lib/utils/zone-url.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  cardTransactionHistoryItemTemplate,
  exchangeTransactionHistoryItemTemplate,
  quickLinkTemplate,
  titleTemplate,
  transactionHistoryItemTemplate,
} from '@finxone-platform/shared/default-templates';
import { AlertHandlerService, IconCacheService } from '@finxone-platform/shared/services';
import {
  APP_ZONES,
  AccountContextOptions,
  AlertTypes,
  BaseCssProperties,
  CardPaymentStatus,
  CardPaymentType,
  CardTransactionInfoType,
  CardTransactionType,
  Constants,
  CurrencyExchangeTransactionType,
  DocumentActionType,
  DownloadDocumentTypeKey,
  ExchangeCurrencyTransactionsResponse,
  ListActionValue,
  NavigationOptionEnum,
  NavigationOptionsType,
  ProviderClass,
  ProviderTransactionType,
  ScheduledPaymentResponseType,
  TransactionCategory,
  TransactionContextOptions,
  TransactionFilterOptions,
  TransactionStatus,
  TransactionType,
  UiZoneWidgetAttributeConfig,
  ViewType,
  ZoneActionOptions,
  baseCssConfigStyle,
  resolveSkeletonLoadingTemplate,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import {
  Observable,
  Subject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  of,
  switchMap,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import {
  ClearExchangeTransactionDetails,
  ClearTransactionDetails,
  ClearTransactionReceiptFileData,
  GetExchangeTransactionById,
  GetScheduledTransactionDetailsById,
  GetTransactionById,
  GetTransactionReceiptFileId,
  GetTransactions,
  SetLoadingStatus,
} from '../../../lib/actions/transactions.action';
import {
  TransactionInfoType,
  TransactionStateType,
} from '../../../lib/services/account-service/account.type';
import { ConfigService } from '../../../lib/services/config-service/config-service.service';
import { AccountState, AccountStateModel } from '../../../lib/state/account.state';
import { TransactionState } from '../../../lib/state/transaction.state';
import { FilterChangeEvent } from '../../shared/components-library/filter-container/filter-container.component';
import { BaseComponent } from '../widgets/base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-recent-transaction-history-widget',
  templateUrl: './recent-transaction-history-widget.component.html',
  styleUrls: ['./recent-transaction-history-widget.component.scss'],
})
export class RecentTransactionHistoryWidgetComponent
  extends BaseComponent
  implements OnInit, AfterContentInit
{
  @Input() dateFrom: string | null;
  @Input() dateTo: string | null;
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  todayDate = formatDate(new Date(), 'd MMMM', 'en');
  transactionData:
    | TransactionInfoType[]
    | ExchangeCurrencyTransactionsResponse[]
    | CardTransactionInfoType[]
    | ScheduledPaymentResponseType[] = [];
  accountId: string;
  roles: Observable<any>;
  roleInfo: any;
  @Select(AccountState.getAccounts)
  accounts!: Observable<AccountStateModel>;
  @Select(SavingsAccountState.getAccounts)
  savingsAccounts!: Observable<SavingsAccountStateModel>;
  @Select(TransactionState.getTransactions)
  transactions!: Observable<TransactionStateType>;
  @Select(CardManagementState.getCardTransactionDetail)
  cardTransactionDetail!: Observable<any>;
  prevdateFrom: string | null;
  @Input() class: string | null;
  widgetGridConfig!: WidgetGridConfig;
  borderContentStyle: baseCssConfigStyle;
  pageNumber = 1;
  totalPages = 1;
  cacheIsEmpty = false;
  @Input() currentTransactionType: TransactionType | CurrencyExchangeTransactionType =
    TransactionType.ALL || CurrencyExchangeTransactionType.CURRENCYALL;
  transactionContext: TransactionContextOptions = TransactionContextOptions.TRANSACTION;
  public accountContext: AccountContextOptions = AccountContextOptions.NONE;
  public transactionOptions: { label: string; value: string }[] = [
    {
      label: 'In',
      value: TransactionType.INCOMING,
    },
    {
      label: 'Out',
      value: TransactionType.OUTGOING,
    },
    {
      label: 'All',
      value: TransactionType.ALL,
    },
  ];

  transactionTypeForm: FormGroup;

  public renderedTitleTemplate = 'Transactions';
  public renderedQuickLinkTemplate = 'See more';

  public TransactionHistoryTopRightOption = TransactionHistoryTopRightOption;
  public currency = '';

  //creates css variables to set the background and text colour for the All,In,Out tab options on the transaction history from the RHS config
  //this is because of the way the p-selectButton element works in form group it cant be done in the HTML
  @HostBinding('style.--activeTransactionTypeTabBackgroundColorVar')
  public activeTransactionTypeTabBackgroundColorVar: string = this.activeTxTypeBackgroundColor;
  @HostBinding('style.--inactiveTransactionTypeTabBackgroundColorVar')
  public inactiveTransactionTypeTabBackgroundColorVar: string = this.inactiveTxTypeBackgroundColor;
  @HostBinding('style.--activeTransactionTypeTabTextColorVar')
  public activeTransactionTypeTabTextColorVar: string = this.activeTxTypeTextColor;
  @HostBinding('style.--inactiveTransactionTypeTabTextColorVar')
  public inactiveTransactionTypeTabTextColorVar: string = this.inactiveTxTypeTextColor;

  @HostBinding('style.--tab-border-top-left-radius')
  public tabBorderTopLeftRadius: string;
  @HostBinding('style.--tab-border-bottom-left-radius')
  public tabBorderBottomLeftRadius: string;
  @HostBinding('style.--tab-border-top-right-radius')
  public tabBorderTopRightRadius: string;
  @HostBinding('style.--tab-border-bottom-right-radius')
  public tabBorderBottomRightRadius: string;
  @HostBinding('style.--tab-border-width') public tabBorderWidth: string;
  @HostBinding('style.--tab-border-style') public tabBorderStyle: string;
  @HostBinding('style.--tab-border-color') public tabBorderColor: string;

  public isApiInProgress = true;
  @Select(ApiLoadingState.getApiState(ApiActions.getTransactions))
  private getTransactionsApiState$!: Observable<{ isLoading: boolean }>;
  @Select(ApiLoadingState.getApiState(ApiActions.getCardTransactions))
  private getCardTransactionsApiState$!: Observable<{ isLoading: boolean }>;
  nestedButtonContentStyle: baseCssConfigStyle;
  nestedButtonContentStyleBorder: baseCssConfigStyle;
  nestedListStyle: baseCssConfigStyle;

  @HostBinding('style.--buttonBorderWidth')
  public buttonBorderWidth: string;
  public defaultTransactionTypeValue: CardTransactionType;
  public isCardTransactions: boolean;
  private isProcessingFilterChange = false;
  private currentCardId: string;
  private isFetching = false;
  public fetchingContent: string;
  public noRecordsContent: string;
  public appBuilderShowFetchingContent = false;
  public appBuilderShowNoRecordsContent = false;
  public viewType = ViewType.LIST;
  public totalItems: number;
  public actionOptions: ZoneActionOptions[] = [];
  public enableClickableRow = true;
  public menuPopupCss = {};
  public searchText: string;
  public selectedOption: { label: string; value: string };
  public filterOptions: { name: string; value: string; isActive: boolean }[] = [];
  public filtersEnabled = false;
  public filterMarginStyle: baseCssConfigStyle;
  public currentStatusFilters: CardPaymentStatus[] | TransactionStatus[] = [];
  public currentTypeFilters: CardPaymentType[] | TransactionType = [];

  public totalListDisabled = false;

  constructor(
    private store: Store,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private matIconRegistry: MatIconRegistry,
    santizer: DomSanitizer,
    private configService: ConfigService,
    private router: Router,
    private iconCacheService: IconCacheService,
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private accountService: AccountService,
    private alertService: AlertHandlerService,
  ) {
    super();
    this.currentTransactionType = this.defaultTransactionType;
    this.accountId = this.store.selectSnapshot(AccountState.getCurrentAccount)?.accountId ?? '';
    this.renderedTitleTemplate = Handlebars.compile(this.titleTemplate)({});
    this.renderedQuickLinkTemplate = Handlebars.compile(this.quickLinkTextContent)({});
    this.defaultTransactionTypeValue = this.dataIn?.attri?.['defaultTransactionType'];
    this.transactionContext =
      this.dataIn?.attri?.['transactionContext'] ?? TransactionContextOptions.TRANSACTION;
    this.accountContext = this.dataIn?.attri?.['accountContext'] ?? AccountContextOptions.NONE;
    this.isCardTransactions = this.defaultTransactionTypeValue === CardTransactionType.CARD_TRANSACTION_ALL;
    this.actionOptions = this.dataIn?.attri?.widgetProperties?.['menuOptions'];

    const isThisbankProvider =
      store.selectSnapshot(ProjectSettingsState.getProjectServiceProvider) === 'thisbank';
    if (isThisbankProvider) {
      // Thisbank have no transaction detail api hence the click through behaviour must be disabled
      this.enableClickableRow = false;
    } else {
      this.enableClickableRow = true;
    }

    this.transactionOptions = this.transactionTypeSelectorOptions.map((option) => {
      if (
        option === TransactionType.ALL ||
        option === CurrencyExchangeTransactionType.CURRENCYALL ||
        option === CardTransactionType.CARD_TRANSACTION_ALL
      ) {
        return {
          label: 'All',
          value: option,
        };
      }

      if (
        option === TransactionType.INCOMING ||
        option === CurrencyExchangeTransactionType.CURRENCYINCOMING
      ) {
        return {
          label: 'In',
          value: option,
        };
      }

      if (
        option === TransactionType.OUTGOING ||
        option === CurrencyExchangeTransactionType.CURRENCYOUTGOING
      ) {
        return {
          label: 'Out',
          value: option,
        };
      }

      // Default case
      return {
        label: 'All',
        value: option, // Use the actual option value
      };
    });
    this.selectedOption =
      this.transactionOptions?.find((option) => option?.value === this.currentTransactionType) ??
      this.transactionOptions[0];
    this.matIconRegistry.addSvgIconLiteral(
      'credit-symbol',
      santizer.bypassSecurityTrustHtml(window.atob(this.creditBackgroundImage)),
    );
    this.matIconRegistry.addSvgIconLiteral(
      'debit-symbol',
      santizer.bypassSecurityTrustHtml(window.atob(this.debitBackgroundImage)),
    );

    this.iconCacheService.setIcon('credit-symbol', window.atob(this.creditBackgroundImage));
    this.iconCacheService.setIcon('debit-symbol', window.atob(this.debitBackgroundImage));

    this.setTabBorderStyles();

    const isAndariaProvider =
      store.selectSnapshot(ProjectSettingsState.getProjectServiceProvider) === 'andaria';
    if (isAndariaProvider) {
      this.totalListDisabled = true;
    }
  }
  public onCheckGetCurrencyConfig() {
    const isCurrencyExchange = this.transactionTypeSelectorOptions?.some(
      (item) => item === CurrencyExchangeTransactionType.CURRENCYINCOMING,
    );
    if (isCurrencyExchange) {
      this.currency = this.store.selectSnapshot(AccountState.getCurrentAccountDetails(this.accountId!))
        ?.currency as string;
    }
  }

  private buildForm() {
    this.transactionTypeForm = new FormGroup({
      transactionType: new FormControl(this.currentTransactionType),
    });
  }

  ngOnInit() {
    this.buildForm();
    if (this.dataIn != undefined) {
      this.attri = this.dataIn.attri;
      this.viewType = this.dataIn.attri['viewType'] ?? ViewType.LIST;
      // little bit of a workaround to show different states in the app builder to preview
      // probably a better way to do this ....
      if (this.configService.getActiveConfigType().isWorkflow) {
        // Assigned, not only ever set: switching the preview back to Default has to clear the
        // state again, in either view.
        const appBuilderState = this.attri?.widgetProperties['appBuilderState'];
        this.appBuilderShowFetchingContent = appBuilderState === 'fetching';
        this.appBuilderShowNoRecordsContent = appBuilderState === 'noRecords';
      }
      this.filterOptions =
        this.attri['filterPillConfig']?.['filterOptions']?.map((option: { name: string; value: string }) => ({
          name: option.name,
          value: option.value,
          isActive: false,
        })) ?? [];
      this.filtersEnabled = this.attri['filterPillConfig']?.['isEnabled'] ?? false;
      const fetchingTemplate = Handlebars.compile(this.attri?.['fetchingTemplate'] ?? '');
      const noRecordsTemplate = Handlebars.compile(this.attri?.['noRecordsTemplate'] ?? '');

      // The designed skeleton wins over the fetching template, so the app-builder canvas preview
      // and the live app render the same loading state from one config. In table view the table
      // draws the skeleton as real rows and cells, so the fetching template stays as it is.
      this.fetchingContent = resolveSkeletonLoadingTemplate(
        this.attri?.['skeletonLayoutConfig'],
        filterIfHandlebarNotRendered(fetchingTemplate({})),
        this.viewType,
      );
      this.noRecordsContent = filterIfHandlebarNotRendered(noRecordsTemplate({}));

      const nestedButtonWidgetConfig = this.nestedButtonContentConfig;
      this.nestedButtonContentStyle = this.configService.getSpecificBaseCssStyle(nestedButtonWidgetConfig, [
        BaseCssProperties.MARGIN,
      ]);
      this.nestedButtonContentStyleBorder = this.configService.getSpecificBaseCssStyle(
        nestedButtonWidgetConfig,
        [BaseCssProperties.PADDING],
      );

      this.nestedListStyle = {
        ...this.configService.getSpecificBaseCssStyle(this.nestedListContentConfig, [
          BaseCssProperties.PADDING,
          BaseCssProperties.MARGIN,
          BaseCssProperties.BORDER,
          BaseCssProperties.BACKGROUND_COLOR,
        ]),
        height: '90%',
      };

      this.filterMarginStyle = this.configService.getSpecificBaseCssStyle(this.attri['filterPillConfig'], [
        BaseCssProperties.MARGIN,
      ]);
    }

    /* For card transactions, there is no need to check the account.
      As a result, the account list is not being called */
    if (this.defaultTransactionTypeValue === CardTransactionType.CARD_TRANSACTION_ALL) {
      this.getCardTransactions();
    } else {
      if (
        this.transactionContext === TransactionContextOptions.SAVINGS_TRANSACTION ||
        (this.transactionContext === TransactionContextOptions.SCHEDULED_PAYMENTS &&
          this.accountContext === AccountContextOptions.SAVINGS_ACCOUNT)
      ) {
        this.savingsAccounts
          .pipe(
            map((response) => response?.activeAccountId),
            distinctUntilChanged(),
            debounceTime(300),
            takeUntil(this.destroy$),
          )
          .subscribe((currentAccountId) => {
            if (this.defaultTransactionTypeValue === CardTransactionType.CARD_TRANSACTION_ALL) {
              return;
            }
            /* First, we check if the account ID matches the current account ID.
                If it matches, we call getRecentTransactions().
                Otherwise, we call the getAccount() action.
                Note: Removing the debounce can result in a 'bad account request' error which shows up after login from one account and then switching to another
            */
            if (this.accountId !== currentAccountId) {
              if (currentAccountId) {
                this.accountId = currentAccountId;
                this.onCheckGetCurrencyConfig();
                this.getRecentTransactions();
              } else {
                this.store.dispatch(new GetSavingAccount());
              }
            } else {
              this.getRecentTransactions();
            }
          });
      } else {
        this.accounts
          .pipe(distinctUntilChanged(), debounceTime(300), takeUntil(this.destroy$))
          .subscribe((response) => {
            const currentAccountId = response?.currentAccountId;
            this.currency = ifMultiCurrencyAccountSetCurrencyConfig(response);
            if (this.defaultTransactionTypeValue === CardTransactionType.CARD_TRANSACTION_ALL) {
              return;
            }
            /* First, we check if the account ID matches the current account ID.
                If it matches, we call getRecentTransactions().
                Otherwise, we call the getAccount() action.
                Note: Removing the debounce can result in a 'bad account request' error which shows up after login from one account and then switching to another
            */
            if (this.accountId !== currentAccountId) {
              if (currentAccountId) {
                this.accountId = currentAccountId;
                this.onCheckGetCurrencyConfig();
                this.getRecentTransactions();
              } else {
                this.store.dispatch(new GetAccount());
              }
            } else {
              this.getRecentTransactions();
            }
          });
      }
    }

    if (this.widgetGridConfig) {
      const hostElem = this.elementRef.nativeElement;
      this.renderer.setStyle(hostElem, 'grid-row', this.widgetGridConfig?.gridPosition.gridRow);
      this.renderer.setStyle(hostElem, 'grid-column', this.widgetGridConfig?.gridPosition.gridCol);
    }
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BORDER,
    ]);
    this.menuPopupCss = {
      right: '8%',
      'margin-top': '5px',
      'border-radius': '6px',
    };
  }

  ngAfterContentInit() {
    if (!this.prevdateFrom) {
      this.prevdateFrom = this.dateFrom;
    }
    if (this.prevdateFrom != this.dateFrom) {
      this.prevdateFrom = this.dateFrom;
    }
  }

  public navigate() {
    this.router.navigateByUrl(`/zones/${formatNameAsUrl(this.quickLinkZone)}/${this.quickLinkPageUrl}`);
  }

  private onGetCalledLoaderSubscription(): void {
    this.getTransactionsApiState$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.isApiInProgress = result.isLoading;
    });
  }
  private onGetCardTransactionLoaderSubscription(): void {
    this.getCardTransactionsApiState$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.isApiInProgress = result.isLoading;
    });
  }

  public getCardTransactions() {
    this.currentCardId = this.store.selectSnapshot(CardState.getCurrentCardId);
    this.cardTransactionDetail
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged((prev, curr) => {
          // Only emit if the actual transaction data changed
          return JSON.stringify(prev.result) === JSON.stringify(curr.result);
        }),
        map((response) => {
          this.getSnapshotOfStateOrDefault();
          this.transactionData = response.result;
        }),
      )
      .subscribe();

    this.dispatchGetCardTransactions({ cardId: this.currentCardId }).subscribe();
    this.onGetCardTransactionLoaderSubscription();
  }

  public getRecentTransactions() {
    this.transactions
      .pipe(
        takeUntil(this.destroy$),
        map(() => {
          this.takeSnapshotOfStateOrDefault();
        }),
      )
      .subscribe();

    this.dispatchGetTransactions({ page: 1, type: this.currentTransactionType }).subscribe();
    this.onGetCalledLoaderSubscription();
  }

  public selectTransactionType(option: { label: string; value: string }) {
    this.transactionTypeForm.get('transactionType')?.setValue(option.value);
    this.getSelectedTransactionType({
      value: option.value as TransactionType | CurrencyExchangeTransactionType,
    });
  }

  public getSelectedTransactionType(transactionType: {
    value?: TransactionType | CurrencyExchangeTransactionType;
  }) {
    if (!transactionType.value) return;
    this.currentTransactionType = transactionType.value;
    this.currentStatusFilters = [];
    this.takeSnapshotOfStateOrDefault();
    this.dispatchGetTransactions({
      type: transactionType.value,
      page: 1,
    });
  }

  private takeSnapshotOfStateOrDefault() {
    const txs = this.store.selectSnapshot(TransactionState.getTransactions);
    if (
      txs.accounts === undefined ||
      txs.accounts[this.accountId] === undefined ||
      txs.accounts[this.accountId][this.currentTransactionType] === undefined
    ) {
      this.pageNumber = 1;
      this.totalPages = 1;
      this.transactionData = [];
    } else {
      this.transactionData = txs.accounts[this.accountId][this.currentTransactionType].result;
      this.pageNumber = txs.accounts[this.accountId][this.currentTransactionType].page;
      this.totalPages = txs.accounts[this.accountId][this.currentTransactionType].totalPages;
      this.totalItems = txs.accounts[this.accountId][this.currentTransactionType].totalItems;
      if (this.transactionData.length === 0) {
        this.cacheIsEmpty = true;
      }
    }
  }

  private getSnapshotOfStateOrDefault() {
    const txs = this.store.selectSnapshot(CardManagementState.getCardManagementState);
    this.transactionData = txs.cardTransactionDetail.result;
    this.totalPages = txs.cardTransactionDetail.totalPages ?? 1;
    this.totalItems = txs.cardTransactionDetail.totalItems ?? 1;
    this.pageNumber = txs.cardTransactionDetail.page;
  }

  public onClickAction(event: any) {
    if (event?.navigationOptionConfig) {
      const navigationUrl = this.handleListActionNavigation(event.navigationOptionConfig);
      this.router.navigateByUrl(navigationUrl);
    }
  }

  public onClickTransactionRow(event: any, navigationOptionConfig?: NavigationOptionsType): void {
    navigationOptionConfig = this.buildNavigationOptionConfig(navigationOptionConfig);

    if (navigationOptionConfig?.navigationOption === NavigationOptionEnum.USE_AS_BLANK) return;

    if (this.isCardTransaction()) {
      this.handleCardTransaction(event, navigationOptionConfig);
      return;
    }

    if (this.isCurrencyExchangeTransaction()) {
      this.handleExchangeTransaction(event, navigationOptionConfig);
      return;
    }

    if (this.isStandardTransaction(event)) {
      this.handleStandardTransaction(event, navigationOptionConfig);
    }
  }

  private handleCardTransaction(event: any, navigationOptionConfig?: NavigationOptionsType): void {
    const url = this.buildNavigationUrl(
      APP_ZONES.CARD_MANAGEMENT_ZONE,
      'card-transactions',
      navigationOptionConfig,
    );

    // The detail route needs the card the transaction belongs to (the backend
    // asserts ownership and linkage); the rows on screen were fetched for the
    // current card, so that is the card the clicked transaction is on.
    const cardId = this.currentCardId ?? this.store.selectSnapshot(CardState.getCurrentCardId);
    this.store
      .dispatch(new GetCardTransactionDetailById(cardId, event.id))
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.router.navigateByUrl(url)),
      )
      .subscribe();
  }

  private handleExchangeTransaction(event: any, navigationOptionConfig?: NavigationOptionsType): void {
    this.store.dispatch(new ClearTransactionDetails());

    const transactionType = this.mapCurrencyExchangeToTransactionType(this.currentTransactionType);

    const url = this.buildNavigationUrl(
      APP_ZONES.PAYMENT,
      'transaction-elaborated-view',
      navigationOptionConfig,
    );

    this.store
      .dispatch(new GetExchangeTransactionById(event.id, transactionType))
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.router.navigateByUrl(url)),
      )
      .subscribe();
  }

  private handleStandardTransaction(event: any, navigationOptionConfig?: NavigationOptionsType): void {
    this.store.dispatch(new ClearTransactionReceiptFileData());

    if (this.transactionContext === TransactionContextOptions.SCHEDULED_PAYMENTS) {
      this.handleScheduledTransaction(event, navigationOptionConfig);
      return;
    }

    const transactionType = this.resolveTransactionType(event);

    this.store.dispatch(new ClearExchangeTransactionDetails());
    this.store
      .dispatch(
        new GetTransactionById(
          event?.transactionNumber ?? '',
          event?.id ?? '',
          transactionType,
          this.accountId,
        ),
      )
      .pipe(
        switchMap(() => {
          const currentTransactionId = this.store.selectSnapshot(
            TransactionState.getTransactions,
          ).currentTransactionId;

          return this.store.dispatch(
            new GetTransactionReceiptFileId(DocumentActionType.TRANSACTIONS, currentTransactionId),
          );
        }),
      )
      .subscribe(() => {
        const url = this.buildNavigationUrl(
          APP_ZONES.PAYMENT,
          'transaction-elaborated-view',
          navigationOptionConfig,
        );
        this.router.navigateByUrl(url);
      });
  }

  private handleScheduledTransaction(event: any, navigationOptionConfig?: NavigationOptionsType): void {
    this.store.dispatch(new ClearTransactionDetails());

    const url = this.buildNavigationUrl(
      APP_ZONES.PAYMENT,
      'transaction-elaborated-view',
      navigationOptionConfig,
    );

    this.store
      .dispatch(new GetScheduledTransactionDetailsById(event?.id, this.currentTransactionType))
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.router.navigateByUrl(url)),
      )
      .subscribe();
  }

  private buildNavigationUrl(
    zone: APP_ZONES,
    route: string,
    navigationOptionConfig?: NavigationOptionsType,
  ): string {
    let url = this.configService.reRouteIfModal(zone, route);

    if (navigationOptionConfig) {
      url = createRedirectionUrlFromNavigationOptions(navigationOptionConfig);
    }

    return url;
  }

  private isCardTransaction(): boolean {
    return this.defaultTransactionTypeValue === CardTransactionType.CARD_TRANSACTION_ALL;
  }

  private isCurrencyExchangeTransaction(): boolean {
    return (
      this.currentTransactionType === CurrencyExchangeTransactionType.CURRENCYALL ||
      this.currentTransactionType === CurrencyExchangeTransactionType.CURRENCYINCOMING ||
      this.currentTransactionType === CurrencyExchangeTransactionType.CURRENCYOUTGOING
    );
  }

  private isStandardTransaction(event: any): boolean {
    return (
      event.providerTransactionType !== ProviderTransactionType.GENERIC &&
      [
        TransactionType.ALL,
        TransactionType.INCOMING,
        TransactionType.OUTGOING,
        TransactionType.SCHEDULED,
      ].includes(this.currentTransactionType as TransactionType)
    );
  }

  private resolveTransactionType(event: any): TransactionType {
    if (this.currentTransactionType === TransactionType.ALL) {
      if (event.providerTransactionType) {
        return event.providerTransactionType === ProviderTransactionType.INCOMING
          ? TransactionType.INCOMING
          : TransactionType.OUTGOING;
      }

      return event.transactionType === TransactionCategory.CREDIT
        ? TransactionType.INCOMING
        : TransactionType.OUTGOING;
    }

    return this.currentTransactionType as TransactionType;
  }

  /**
   * Builds and returns a NavigationOptionsType object.
   *
   * Logic:
   * - If a navigationOptionConfig is already provided, it returns it directly.
   * - If required attributes navigationOption are missing,
   *   it returns the existing navigationOptionConfig (undefined or provided).
   * - Otherwise, it constructs a new NavigationOptionsType object
   *   using values from this.attri.
   *
   * @param navigationOptionConfig - Optional pre-existing navigation configuration.
   * @returns NavigationOptionsType | undefined
   */
  private buildNavigationOptionConfig(
    navigationOptionConfig?: NavigationOptionsType,
  ): NavigationOptionsType | undefined {
    if (navigationOptionConfig || !this.attri?.['navigationOption']) {
      return navigationOptionConfig;
    }

    const navConfig: NavigationOptionsType = {
      navigationOption: this.dataIn.attri?.['navigationOption'],
      zone: this.dataIn.attri?.['zone'],
      pageUrl: this.dataIn.attri?.['pageUrl'],
      pageId: this.dataIn.attri?.['pageId'],
      pageTransition: this.dataIn.attri?.['pageTransition'],
      role: this.dataIn.attri?.['role'],
      tabRef: this.dataIn.attri?.['tabRef'],
      externalUrl: this.dataIn.attri?.['externalUrl'],
    };
    return navConfig;
  }

  handleChildScroll() {
    if (this.pagingEnabled && !this.isFetching) {
      if (this.pageNumber != this.totalPages) {
        this.isFetching = true;
        this.store.dispatch(new SetLoadingStatus(true));
        const prePageNumber = this.pageNumber;
        this.pageNumber = this.pageNumber + 1;

        if (this.defaultTransactionTypeValue !== CardTransactionType.CARD_TRANSACTION_ALL) {
          if (prePageNumber !== this.pageNumber) {
            this.dispatchGetTransactions({
              page: this.pageNumber,
              txsViewType: ViewType.LIST,
              isLoaderShown: false,
            }).subscribe({
              next: () => (this.isFetching = false),
              error: (err) => (this.isFetching = false),
            });
          }
        } else {
          this.dispatchGetCardTransactions({
            page: this.pageNumber,
            viewType: ViewType.LIST,
            isLoaderShown: false,
          }).subscribe({
            next: () => (this.isFetching = false),
            error: (err) => (this.isFetching = false),
          });
        }
      }
    }
  }

  private get nestedListContentConfig(): UiZoneWidgetAttributeConfig {
    if (this.dataIn.widgetConfig?.nestedWidgets?.['transactionList'])
      return this.dataIn.widgetConfig?.nestedWidgets?.['transactionList'];
    else
      return {
        widgetProperties: {
          textContent: '',
        },
        elementsConfig: [],
        css_config: {
          ...Constants.defaultUiNestedTransactionListCssConfig,
        },
      };
  }

  private get nestedButtonContentConfig(): UiZoneWidgetAttributeConfig {
    if (this.dataIn.widgetConfig?.nestedWidgets?.['transactionButtons'])
      return this.dataIn.widgetConfig?.nestedWidgets?.['transactionButtons'];
    else
      return {
        widgetProperties: {
          textContent: '',
        },
        elementsConfig: [],
        css_config: {
          ...Constants.defaultUiNestedTransactionButtonCssConfig,
        },
      };
  }

  public get titleTemplate(): string {
    if (this.dataIn.attri['titleTemplate'] != null) return this.dataIn.attri['titleTemplate'];
    else return titleTemplate;
  }

  /**
   * The loading state the table draws: the real API call, or the builder's Fetching preview. The
   * running app never sets the preview flag.
   */
  public get listingApiInProgress(): boolean {
    return this.isApiInProgress || this.appBuilderShowFetchingContent;
  }

  /**
   * Table view. The app-builder canvas fills `transactionData` from the mock services, so the
   * Fetching preview has to hand the table nothing — otherwise the mock rows sit on top of the
   * loading state being previewed, and neither the skeleton nor the fetching template is seen.
   */
  public get listingEntityData(): typeof this.transactionData {
    return this.appBuilderShowFetchingContent ? [] : this.transactionData;
  }

  public get pageSize(): number {
    if (this.dataIn.attri['pageSize'] != null)
      return +this.dataIn.attri['pageSize']; // + to cast to number
    else return 10;
  }

  public get pagingEnabled(): boolean {
    if (this.dataIn.attri['pagingEnabled'] != null) return this.dataIn.attri['pagingEnabled'];
    else return true;
  }
  public get defaultTransactionType(): TransactionType | CurrencyExchangeTransactionType {
    if (this.dataIn.attri['defaultTransactionType'] != null)
      return this.dataIn.attri['defaultTransactionType'];
    return TransactionType.ALL || CurrencyExchangeTransactionType.CURRENCYALL;
  }
  public get topRightOption(): TransactionHistoryTopRightOption {
    if (this.dataIn.attri?.['topRightConfiguration']?.['option'] != null)
      return this.dataIn.attri['topRightConfiguration']['option'];
    else return TransactionHistoryTopRightOption.TRANSACTION_TYPE_SELECTOR;
  }
  public get transactionTypeSelectorOptions(): (
    TransactionType | CurrencyExchangeTransactionType | CardTransactionType
  )[] {
    if (this.dataIn.attri?.['topRightConfiguration']?.['transactionTypeSelectorOptions'] != null)
      return this.dataIn.attri['topRightConfiguration']['transactionTypeSelectorOptions'];
    else
      return [
        TransactionType.INCOMING,
        TransactionType.OUTGOING,
        TransactionType.ALL,
        CurrencyExchangeTransactionType.CURRENCYALL,
        CurrencyExchangeTransactionType.CURRENCYINCOMING,
        CurrencyExchangeTransactionType.CURRENCYOUTGOING,
        CardTransactionType.CARD_TRANSACTION_ALL,
      ];
  }
  public get quickLinkTextContent(): string {
    if (this.dataIn.attri?.['topRightConfiguration']?.['quickLinkOptions']?.['textContent'] != null)
      return this.dataIn.attri['topRightConfiguration']['quickLinkOptions']['textContent'];
    else return quickLinkTemplate;
  }
  public get quickLinkZone(): APP_ZONES {
    if (this.dataIn.attri?.['topRightConfiguration']?.['quickLinkOptions']?.['zone'] != null)
      return this.dataIn.attri['topRightConfiguration']['quickLinkOptions']['zone'];
    else return APP_ZONES.LANDING;
  }
  public get quickLinkPageUrl(): string {
    if (this.dataIn.attri?.['topRightConfiguration']?.['quickLinkOptions']?.['pageUrl'] != null)
      return this.dataIn.attri['topRightConfiguration']['quickLinkOptions']['pageUrl'];
    else return 'home';
  }

  public get transactionHistoryItemTemplate(): string {
    if (this.dataIn.attri?.['transactionItemConfig']?.['transactionHistoryItemTemplate'] != null)
      return this.dataIn.attri['transactionItemConfig']['transactionHistoryItemTemplate'];
    return (
      transactionHistoryItemTemplate ||
      exchangeTransactionHistoryItemTemplate ||
      cardTransactionHistoryItemTemplate
    );
  }

  public get transactionHistoryImageEnabled(): boolean {
    if (this.dataIn.attri?.['transactionItemConfig']?.['imageEnabled'] != null)
      return this.dataIn.attri['transactionItemConfig']['imageEnabled'];
    else return true;
  }

  public get creditBackgroundImage(): string {
    if (this.dataIn.attri?.['transactionItemConfig']?.['creditBackgroundImage'] != null)
      return this.dataIn.attri['transactionItemConfig']['creditBackgroundImage'];
    else
      return 'PHN2ZyB2aWV3Qm94PSIwIDAgNTYgNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZml0PSIiIGhlaWdodD0iMTAwJSIgICAgIHdpZHRoPSIxMDAlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0IiBmb2N1c2FibGU9ImZhbHNlIj4gICAgIDxyZWN0IHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiIgcng9IjIwIiBmaWxsPSIjRTNFOEYzIj48L3JlY3Q+ICAgICA8cGF0aCBkPSJNMjMgMzNMMzMgMjNNMzMgMjNIMjNNMzMgMjNWMzMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiAgICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD4gPC9zdmc+';
  }

  public get debitBackgroundImage(): string {
    if (this.dataIn.attri?.['transactionItemConfig']?.['debitBackgroundImage'] != null)
      return this.dataIn.attri['transactionItemConfig']['debitBackgroundImage'];
    else
      return 'PHN2ZyB2aWV3Qm94PSIwIDAgNTYgNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZml0PSIiIGhlaWdodD0iMTAwJSIgICAgIHdpZHRoPSIxMDAlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0IiBmb2N1c2FibGU9ImZhbHNlIj4gICAgIDxyZWN0IHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiIgcng9IjIwIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSA1NiAwKSIgZmlsbD0iI0ZFQ0RDQSI+PC9yZWN0PiAgICAgPHBhdGggZD0iTTMzIDIzTDIzIDMzTTIzIDMzVjIzTTIzIDMzSDMzIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+IDwvc3ZnPg==';
  }

  public get imageCssProps(): any {
    if (this.dataIn.attri?.['transactionItemConfig']?.['imageCssProps'] != null)
      return this.dataIn.attri['transactionItemConfig']['imageCssProps'];
    else
      return {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        marginUnit: 'px',
      };
  }

  public get activeTxTypeBackgroundColor(): string {
    if (
      this.dataIn.attri?.['topRightConfiguration']?.['transactionTypeStyles']?.['activeBackgroundColor'] !=
      null
    )
      return this.dataIn.attri['topRightConfiguration']['transactionTypeStyles']['activeBackgroundColor'];
    else return 'var(--color-primary) !important';
  }

  public get inactiveTxTypeBackgroundColor(): string {
    if (
      this.dataIn.attri?.['topRightConfiguration']?.['transactionTypeStyles']?.['inactiveBackgroundColor'] !=
      null
    )
      return this.dataIn.attri['topRightConfiguration']['transactionTypeStyles']['inactiveBackgroundColor'];
    else return 'var(--color-surface) !important';
  }

  public get headerAlignment(): string {
    {
      if (this.dataIn.attri['headerAlignment'] != null) return this.dataIn.attri['headerAlignment'];
      return 'space-between';
    }
  }

  private setTabBorderStyles() {
    const nestedButtonWidgetConfig = this.nestedButtonContentConfig;
    const borderStyle = this.configService.getSpecificBaseCssStyle(nestedButtonWidgetConfig, [
      BaseCssProperties.BORDER,
    ]);

    this.tabBorderTopLeftRadius = borderStyle?.['border-top-left-radius'] || '5px';
    this.tabBorderBottomLeftRadius = borderStyle?.['border-bottom-left-radius'] || '5px';
    this.tabBorderTopRightRadius = borderStyle?.['border-top-right-radius'] || '5px';
    this.tabBorderBottomRightRadius = borderStyle?.['border-bottom-right-radius'] || '5px';
    this.tabBorderWidth = borderStyle?.['border-width'] || '1px';
    this.tabBorderStyle = borderStyle?.['border-style'] ?? 'solid';
    this.tabBorderColor = borderStyle?.['border-color'] || 'var(--color-border-color)';
  }

  public get activeTxTypeTextColor(): string {
    if (this.dataIn.attri?.['topRightConfiguration']?.['transactionTypeStyles']?.['activeTextColor'] != null)
      return this.dataIn.attri['topRightConfiguration']['transactionTypeStyles']['activeTextColor'];
    else return 'var(--color-background) !important';
  }

  public get inactiveTxTypeTextColor(): string {
    if (
      this.dataIn.attri?.['topRightConfiguration']?.['transactionTypeStyles']?.['inactiveTextColor'] != null
    )
      return this.dataIn.attri['topRightConfiguration']['transactionTypeStyles']['inactiveTextColor'];
    else return 'var(--color-on-background-muted) !important';
  }

  private mapCurrencyExchangeToTransactionType(
    type: CurrencyExchangeTransactionType | TransactionType,
  ): TransactionType {
    switch (type) {
      case CurrencyExchangeTransactionType.CURRENCYINCOMING:
        return TransactionType.INCOMING;
      case CurrencyExchangeTransactionType.CURRENCYOUTGOING:
        return TransactionType.OUTGOING;
      case CurrencyExchangeTransactionType.CURRENCYALL:
        return TransactionType.ALL;
      default:
        throw new Error('Unknown CurrencyExchangeTransactionType');
    }
  }

  public onPageChange(event: { first: number; page: number; pageCount: number; rows: number }) {
    this.pageNumber = event.first / event.rows + 1;
    this.dataIn.attri['pageSize'] = event.rows;
    if (this.defaultTransactionTypeValue !== CardTransactionType.CARD_TRANSACTION_ALL) {
      this.dispatchGetTransactions({
        page: this.pageNumber,
        txsViewType: ViewType.TABLE,
        isLoaderShown: false,
      }).subscribe({
        next: () => (this.isFetching = false),
        error: (err) => (this.isFetching = false),
      });
    } else {
      this.dispatchGetCardTransactions({
        page: this.pageNumber,
        viewType: ViewType.TABLE,
        isLoaderShown: false,
      }).subscribe({
        next: () => (this.isFetching = false),
        error: (err) => (this.isFetching = false),
      });
    }
  }

  public searchValue(searchText: string) {
    const isCurrencyExchange =
      this.defaultTransactionType === CurrencyExchangeTransactionType.CURRENCYALL ||
      this.defaultTransactionType === CurrencyExchangeTransactionType.CURRENCYINCOMING ||
      this.defaultTransactionType === CurrencyExchangeTransactionType.CURRENCYOUTGOING;
    if (isCurrencyExchange) {
      this.searchText = searchText;
      this.pageNumber = 1;
      this.dispatchGetTransactions({
        page: this.pageNumber,
        txsViewType: ViewType.TABLE,
        isLoaderShown: true,
        searchValue: this.searchText,
      });
    }
  }

  public handleAction(event: any) {
    const data = {
      actionKey: event.actionConfig?.action,
      actionId: event.data?.id || event.data?.transactionNumber || '',
    };
    this.performAction(data, event.actionConfig.navigationOptionConfig);
  }

  public performAction(
    event: { actionKey: string; actionId: string },
    navigationOptionConfig?: NavigationOptionsType,
  ) {
    const isCurrencyExchange =
      this.defaultTransactionType === CurrencyExchangeTransactionType.CURRENCYALL ||
      this.defaultTransactionType === CurrencyExchangeTransactionType.CURRENCYINCOMING ||
      this.defaultTransactionType === CurrencyExchangeTransactionType.CURRENCYOUTGOING;

    const isCardTransaction = this.defaultTransactionTypeValue === CardTransactionType.CARD_TRANSACTION_ALL;
    const isTransaction =
      this.defaultTransactionType === TransactionType.INCOMING ||
      this.defaultTransactionType === TransactionType.OUTGOING;

    const { actionKey, actionId } = event;

    if (
      actionKey === ListActionValue.VIEW_DETAIL &&
      (isCurrencyExchange || isCardTransaction || isTransaction)
    ) {
      this.onClickTransactionRow({ id: actionId }, navigationOptionConfig);
      return;
    }

    if (actionKey === ListActionValue.DOWNLOAD_RECEIPT && isCurrencyExchange) {
      this.downloadExchangeTransactionReceipt(actionId);
    }

    if (actionKey === ListActionValue.DOWNLOAD_RECEIPT && isTransaction) {
      this.downloadTransactionReceipt(actionId);
    }
  }

  private downloadTransactionReceipt(transactionId: string) {
    this.accountService
      .documentPaymentProofDownload(
        this.accountId,
        DownloadDocumentTypeKey.PROOF_OF_PAYMENT_PDF,
        transactionId,
        this.currentTransactionType ?? '',
        'pdf',
      )
      .pipe(
        take(1),
        map((response: unknown) => {
          this.downloadResponse(response, 'pdf');
        }),
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe();
  }

  private downloadExchangeTransactionReceipt(actionId: string): void {
    this.accountService
      .documentExchangeProofDownload(DownloadDocumentTypeKey.PROOF_OF_EXCHANGE_PDF, actionId, '', 'pdf')
      .pipe(
        take(1),
        map((response: unknown) => {
          this.downloadResponse(response, 'pdf');
        }),
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe();
  }

  public onChangeTransactionType(event: any) {
    if (this.defaultTransactionTypeValue !== CardTransactionType.CARD_TRANSACTION_ALL) {
      this.currentTransactionType = event;
      this.takeSnapshotOfStateOrDefault();
      this.dispatchGetTransactions({
        type: event,
        page: 1,
      });
    }
  }

  private downloadResponse(response: unknown, documentType: string) {
    const blob = new Blob([response as BlobPart], {
      type: `application/${documentType}`,
    });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = new Date().getTime() + `.${documentType}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);
  }

  public onFilterChange(filterEvent: FilterChangeEvent) {
    this.isProcessingFilterChange = true;

    this.filterOptions = this.filterOptions.map((f) => {
      return f.value === filterEvent.filterType ? { ...f, isActive: filterEvent.isActive } : f;
    });

    switch (filterEvent.filterType) {
      case TransactionFilterOptions.DATE:
        if (!filterEvent.isActive) this.onDateRangeChange({ dateFrom: null, dateTo: null });
        break;
      case TransactionFilterOptions.STATUS:
        if (!filterEvent.isActive) {
          this.currentStatusFilters = [];
          this.onStatusChange([]);
        }
        break;
      case TransactionFilterOptions.TYPE:
        if (!filterEvent.isActive) {
          this.currentTypeFilters = [];
          this.onTransactionTypeChange([]);
        }
        break;
      default:
        console.warn('Unhandled filter type:', filterEvent.filterType);
    }
    this.isProcessingFilterChange = false;
  }

  public onDateRangeChange(dateRange: { dateFrom: string | null; dateTo: string | null }) {
    if (!validateDateRange(dateRange.dateFrom, dateRange.dateTo)) {
      return this.alertService.showAlertFn(AlertTypes.WARNING, 'End date must come after start date');
    }
    this.dateFrom = dateRange.dateFrom;
    this.dateTo = dateRange.dateTo;
    this.refreshTransactionsWithCurrentFilters();
  }

  public onStatusChange(status: CardPaymentStatus[] | TransactionStatus[]) {
    if (this.isProcessingFilterChange) return;
    this.currentStatusFilters = status;
    this.refreshTransactionsWithCurrentFilters();
  }

  public onTransactionTypeChange(type: CardPaymentType[] | TransactionType) {
    if (this.isProcessingFilterChange) return;
    this.currentTypeFilters = type;
    this.refreshTransactionsWithCurrentFilters();
  }

  private refreshTransactionsWithCurrentFilters(additionalOptions: any = {}) {
    if (this.defaultTransactionTypeValue === CardTransactionType.CARD_TRANSACTION_ALL) {
      this.dispatchGetCardTransactions({
        page: 1,
        status: this.currentStatusFilters,
        type: this.currentTypeFilters,
        ...additionalOptions,
      });
    } else {
      this.dispatchGetTransactions({
        page: 1,
        status: this.currentStatusFilters,
        type: this.currentTransactionType,
        ...additionalOptions,
      });
    }
  }

  /**
   * Centralised method to dispatch GetCardTransactions with all parameters
   */
  private dispatchGetCardTransactions(
    options: {
      cardId?: string;
      page?: number;
      pageSize?: number;
      status?: CardPaymentStatus[];
      type?: CardPaymentType[];
      viewType?: ViewType;
      isLoaderShown?: boolean;
    } = {},
  ): Observable<any> {
    const {
      cardId = this.currentCardId,
      page = 1,
      pageSize = this.pageSize,
      status = [],
      type = [],
      viewType = ViewType.LIST,
      isLoaderShown = true,
    } = options;

    if (!cardId) {
      return this.store.dispatch(new GetCards()).pipe(
        switchMap(() => {
          this.currentCardId = this.store.selectSnapshot(CardState.getCurrentCardId);
          if (this.currentCardId?.length) {
            return this.dispatchGetCardTransactions({ ...options, cardId: this.currentCardId });
          }
          return of(null);
        }),
        catchError((err) => {
          console.error('Error fetching cards:', err);
          return of(null);
        }),
      );
    }
    return this.store.dispatch(
      new GetCardTransactions(
        cardId,
        { page, size: pageSize, dateFrom: this.dateFrom, dateTo: this.dateTo, status, type },
        viewType,
        isLoaderShown,
      ),
    );
  }

  /**
   * Centralized method to dispatch GetTransactions with all parameters
   */
  private dispatchGetTransactions(
    options: {
      accountId?: string;
      page?: number;
      pageSize?: number;
      status?: TransactionStatus[];
      type?: TransactionType | CurrencyExchangeTransactionType;
      currency?: string;
      searchValue?: string;
      txsViewType?: string;
      isLoaderShown?: boolean;
    } = {},
  ): Observable<any> {
    const {
      accountId = this.accountId,
      page = 1,
      pageSize = this.pageSize,
      status = this.currentStatusFilters as TransactionStatus[],
      type = this.currentTransactionType,
      currency = this.currency,
      searchValue = this.searchText,
      txsViewType = ViewType.LIST,
      isLoaderShown = true,
    } = options;

    /**
     * Special case handling for Scheduled Payments with No Account Context:
      - If the transaction context is SCHEDULED_PAYMENTS and the account context is NO_CONTEXT, we allow fetching transactions without an account ID.
      - In this specific scenario, we proceed with dispatching the GetTransactions action even if accountId is not available, as the backend can handle fetching scheduled payments without an account context.
     */
    const isScheduledNoContext =
      this.transactionContext === TransactionContextOptions.SCHEDULED_PAYMENTS &&
      this.accountContext === AccountContextOptions.NONE;
    if (!accountId && !isScheduledNoContext) return of(null);

    return this.store.dispatch(
      new GetTransactions(
        accountId,
        {
          page,
          size: pageSize,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          status,
          type,
          transactionContext: this.transactionContext,
          accountContext: this.accountContext,
          currency,
          searchValue,
        },
        txsViewType,
        isLoaderShown,
      ),
    );
  }

  private handleListActionNavigation(navigationOptionConfig?: NavigationOptionsType): string {
    return this.configService.reRouteIfModal(
      navigationOptionConfig?.zone as APP_ZONES,
      navigationOptionConfig?.pageUrl as string,
    );
  }
}
